import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
* {
  margin: 0;
  padding: 0;
  outline: 0;
  box-sizing: border-box;
}
html, body, #root {
  min-height: 100%;
}
body {
  background: #f5f8fb;
  -webkit-font-smoothing: antialiased !important;
}
body, input, button {
  color: #222;
  font-size: 8px;
  font-family: Arial, Helvetica, sans-serif
}
button {
  cursor: pointer;
}
  .cwuCQv {
    min-width: 30px;
    height: 43px;
  }

  .rsc-os-option-element {
    background: #27ae60;
    color: #f5f8fb;
}
  .ehJpXz {
    border-radius: 0px;
  }
  .bbxcDB {
    border-radius: 0px;
  }
  .rsc-container {
    border-radius: 0px;
  }

`;
